/* eslint-disable class-methods-use-this */
import Flickity from 'flickity-imagesloaded';
import ModalCore from '@studiometa/js-toolkit/components/Modal';
import { isDev } from '../../config';

/**
 * PageProductSliderModal class.
 */
export default class PageProductSliderModal extends ModalCore {
  static config = {
    ...ModalCore.config,
    log: isDev(),
    name: 'PageProductSliderModal',
    refs: [...ModalCore.config.refs, 'slider', 'sliderArrowPrevious', 'sliderArrowNext'],
  };

  slider = null;

  /**
   * Mounted.
   *
   * @return {void}
   */
  mounted() {
    const $this = this;

    this.slider = new Flickity(this.$refs.slider, {
      cellAlign: 'center',
      draggable: true,
      prevNextButtons: false,
      pageDots: false,
      imagesLoaded: true,
      on: {
        ready() {
          $this.$refs.slider.classList.add('is-flickity-ready');
        },
      },
    });
  }

  /**
   * Destroyed
   */
  destroyed() {
    if (this.slider) {
      this.$refs.slider.classList.remove('is-flickity-ready');
      this.slider.destroy();
      this.slider = null;
    }
  }

  /**
   * onSliderArrowPreviousClick
   */
  onSliderArrowPreviousClick() {
    this.slider.previous();
  }

  /**
   * onSliderArrowNextClick
   */
  onSliderArrowNextClick() {
    this.slider.next();
  }
}
